export const mealPlanPageData = [
  {
    heading: "Meal Planner",
    description: {
      plaintext:
        "Plan meals by selecting the date, then choose breakfast, lunch, or dinner.",
    },
    youMayAlsoLikeTitle: "You May Also Like",
    noMealsAdded: "You currently don’t have any meals added.",
    daysOfWeek: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    mealCategories: ["Breakfast", "Lunch", "Snack", "Dinner", "Other"],
    shareMealPlan: "Share meal plan by email",
    copyMealPlan: "Copy meal plan to clipboard",
    print: "Print",
    share: "Share",
    deleteRecipes: "Delete Recipes",
    deleteRecipe: "Delete Recipe",
    addToShoppingList: "Shop for ingredients",
    addMeal: "Add Meal",
    recipeFromOurCollectionAltText: "A recipe from our collection",
    deliciousRecipeAltText: "a delicious recipe",
    logInToAddMealsLabel: "Log in to add meals",
  },
];

export const mealPlanPopupData = [
  {
    printMealPlanHeading: "Print Meal Plan",
    dateRange: "Date Range",
    shareMealPlanHeading: "Share Meal Plan",
    emailLabel: "Email",
    emailPlaceholder: "john.doe@mail.com",
    note: "This email won’t be used for promotions or other communications.",
    copyMealPlanHeading: "Copy Meal Plan",
    singularMessage: "Are you sure to delete this recipe from your meal plan?",
    pluralMessage: "Are you sure to delete these recipes from your meal plan?",
    youArePlanningText: "You are Planning",
    myRecipeListsHeading: "My Recipe Lists",
    chooseRecipeListDescription:
      "Choose a recipe list to add a recipe to your meal plan.",
    saveYourMealPlanHeading: "Save Your Meal Plan!",
    saveYourMealPlanDescription: {
      html: "\u003Cp\u003ELog in now to:\u003C/p\u003E\n\u003Cul\u003E\n\u003Cli\u003ESave recipes to Meal Plan.\u003C/li\u003E\n\u003Cli\u003ECreate and organize new Meal Plan.\u003C/li\u003E\n\u003Cli\u003EAdd recipes to your permanent Meal Plan.\u003C/li\u003E\n\u003C/ul\u003E\n",
    },
    personalNoteHeading: "Save Your Personal Note!",
    personalNoteDescription: {
      html: "\u003Cp\u003ELog in now to:\u003C/p\u003E\n\u003Cul\u003E\n\u003Cli\u003ESave personal notes.\u003C/li\u003E\n\u003Cli\u003ECreate and organize your recipe.\u003C/li\u003E\n\u003Cli\u003EAdd a personal note for your recipe.\u003C/li\u003E\n\u003C/ul\u003E\n",
    },
    cancelButton: "Cancel",
    printButton: "Print",
    loadingButton: "Loading…",
    sendButton: "Send",
    sendingButton: "Sending…",
    copyButton: "Copy",
    copyingButton: "Copying…",
    yesSureButton: "Yes, I m sure",
    saveButton: "Save",
    savingButton: "Saving…",
    browseRecipesButton: "Browse Recipes",
    addFromMyRecipeLists: "Add From My Recipe Lists",
    backToListButton: "Back to List",
    saveChangesButton: "Save Changes",
    viewRecipeButton: "View Recipe",
    loginRegisterButton: "Login / Register",
    closeModalAriaLabel: "Close modal",
    goToHomepageAriaLabel: "Go to Homepage",
    deleteAriaLabel: "Delete",
    goToRecipeDetailPage: "Go to recipe detail page",
    deleteRecipeAriaLabel: "Delete recipe",
    addRecipeAriaLabel: "Add recipe",
    searchRecipesListLabel: "Search Recipes List",
    closeSearchBarLabel: "Close search bar",
    recipeFromOurCollectionAltText: "A recipe from our collection",
    deliciousRecipeAltText: "a delicious recipe",
    searchPlaceholder: "Search",
    logoBlack: "/logos/foodland.png",
    limitExceededTitle: "Limit Exceeded!",
    noSearchResult: "No search results for",
  },
];

export const recipeDetailData = [
  {
    personalNote: "Personal Note",
    enterNotesPlaceholder: "Enter notes..",
    editButton: "Edit",
    deleteButton: "Delete",
    createANoteText: "Create a note",
    viewMealPlan: "View Meal Plan",
    addToMealPlan: "Add to Meal Plan",
    savingText: "Saving...",
    deletePersonalNote: "Are you sure you want to delete this note?",
    cancel: "Cancel",
    sureMessage: "Yes, I m sure",
    noSearchResult: "No search results for",
    removeFromFavourite: "Remove from favorite",
    addToFavourite: "Add to favorite",
  },
];

export const recipeModalData = 
 [
  {
    chooseRecipeList: "Choose Recipe List",
    chooseNewList: "Create New List",
    favoriteToolTip: "Favourites is a default recipe list. All recipes added to any list, are also added to Favourites.",
    cancel: "Cancel",
    save: "Save",
    default: "Default",
    recipeEmptyListMessage: "This list has no recipes. Add recipes to get started!",
    myRecipeList: "My Recipe List",
    addToShoppingList: "Add to Shopping List",
    delete: "Delete",
    saveRecipeList: "Save Recipe List",
    searchRecipes: "Search Recipes",
    browseRecipes: "Browse Recipes",
    deleteTitle: "Are you sure to delete this recipe list?",
    sureMessage: "Yes, I'm sure",
    mergeTitle: "Are you sure to Merge these recipe list?",
    closeTitle: "If you close this window, your progress will be lost.",
    closeMessage: "Make sure to save before exiting!",
    closeAnyway: "Close Anyway",
    recipeDeleteTitle: "Are you sure to delete this recipe from the list?",
    viewListTitle: "View List",
    viewFavouriteListTitle:"View Favourites",
    nameRecipeListTitle: "Name Recipe List",
    noSearchResult: "No search results for",
    addRecipeTitle: "Add Recipe",
    createNewRecipeListTitle: "Create New Recipe List",
    placeholderText: "Type here...",
    searchRecipesTitle: "Search",
    addRecipesToList: "Add Recipe(s) to list",
    loginButton: "Login / Register",
    myRecipeListTitle: "My Recipe Lists",
    addIngredientsToList: "Add Ingredients to list",
    merge: "Merge",
    favourites: "Favourites",
    deleteRecipe: "Delete Recipe",
    login: "Login",
    removeFromFavourite: "Remove from favourite",
    addToFavourite: "Add to favourite",
    savingButtonText: "Saving...",
    loginHeaderTitle: "Save Your Favourite Recipes!",
    loginBodyTitle: "Log in now to:",
    loginPoints: [
      "Save recipes to My Recipe Lists.",
      "Create and organize new Recipe Lists.",
      "Add recipes to your permanent Favourites."
    ],
    viewMealPlan: "View Meal Plan",
    addToMealPlan: "Add to Meal Plan",
    savingText: "Saving..."
  }
]

export const mealPlanDefautMessage = [
  {
    loginMessage: "Heads up! Your \"Add to Favourite\" and \"Add to List\" actions will not be saved unless you are signed in.",
    recipeSuccessfulAdd: "Your Recipe has been saved to your list",
    recipeSuccessfulRemoval: "Your recipe was successfully removed to lists",
    listNameExist: "List name already exists",
    recipeListMerge: "Recipe Lists merged successfully",
    recipeDeleted: "Recipes have been deleted successfully",
    recipeListDeleted: "Recipe list has been deleted successfully",
    recipeListUpdate: "Your recipe list was updated successfully",
    recipeListCreate: "Your recipe list has been created successfully",
    initialSpaceError: "Initial spaces are not allowed.",
    beginErrorMessage: "The name must not begin with an underscore (_) or hyphen (-).",
    endErrorMessage: "The name must not end with an underscore (_) or  hyphen (-).",
    listNameEmptyMessage: "List name cannot be empty.",
    listNameMinChar: "List name must be of minimum 3 characters.",
    listNameMaxChar: "List name must be of maximum 20 characters.",
    specialCharNotAllowed: "Special characters are not allowed.",
    recipeListAlreadyExist: "Recipe list name already exists",
    recipeAlreadyExists: "This Recipe already exists.",
    favouriteRecipeAdded: "Your recipe was successfully added to Favourites.",
    favouriteRecipeRemoved: "Your recipe was successfully removed from Favourites.",
    noRecipeFound: "No Recipes Found",
    adjustOptions: "Try adjusting your options to discover new possibilities!",
    noRecipesMatch: "No recipes match your selected filters.",
    loginToSaveRecipe: "Log in to save recipes to your personal Recipe Lists, create new lists, and add recipes to your Favourites!",
    recipesAddedWithoutLogin: "Recipes added to Favourite without logging in won't be saved permanently.",
    personalNoteTooLong : "Note is too long. Max 256 characters.",
    invalidEmail: "Invalid email address.",
    mealPlanNotAdded: "Unable to add meal plan, Please try again.",
    mealPlanNotRemoved: "Unable to delete Meal Plan, Please try again.",
    mealPlanFetchFailed: "Unable to fetch meal plan data. Please try again.",
    offlineError: "Network Unavailable.",
    serverError: "Something went wrong, Please try again.",
    dataNotFound: "No meal plan data available.",
    mealPlanCopyFailed: "Unable to copy meal plan data, Please try again.",
    personalNoteNotSaved: "Unable to save personal note, Please try again.",
    personalNoteNotDeleted : "Unable to delete personal note, Please try again.",
    noMealPlanRecipeListFound: "No recipe list found.",
    mealPlanRemoved: "Your meal plan was successfully deleted.",
    emailSent: "Your meal plan was successfully sent.",
    mealPlanCopied: "Your meal plan was copied to clipboard.",
    mealPlanAdded: "Your recipe was successfully added to your meal plan.",
    personalNoteSaved: "Your personal note was successfully saved.",
    personalNoteDeleted: "Your personal note was successfully deleted.",
    personalNoteConfirm: "Are you sure you want to delete this note?",
    mealPlanAlreadyExists: "Meal Plan already exists",
    limitExceededTitle: "Limit Exceeded!",
    limitExceededMessage: "You’ve reached the limit of 10 recipes for this date."
  }
]